import { render } from "./index.vue?vue&type=template&id=16cbda64"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"static/js/components-wa/PageFooter/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "16cbda64"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('16cbda64', __exports__)) {
    api.reload('16cbda64', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=16cbda64", () => {
    api.rerender('16cbda64', render)
  })

}


export default __exports__